import { render, staticRenderFns } from "./vergence_jump_base.config.vue?vue&type=template&id=88432b24"
import script from "./vergence_jump_base.config.vue?vue&type=script&lang=js"
export * from "./vergence_jump_base.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports